enum PaymentTypeEnum {
    CREDIT_CARD = 1,
    CASH,
    CHECK,
    TERMS,
}

export default PaymentTypeEnum;
